import { CustomBlock as CustomBlockBase } from "@corca/tiptap";

import { chatbotToolStatusRenderer } from "./custom-block/ChatbotToolStatusView";

/**
 * A universal extension for adding blocks with custom styles to the editor.
 * Dispatches rendering to specific views based on the `blockType` attribute.
 * Unsupported block types fall back to default ProseMirror rendering.
 */
export const CustomBlock = CustomBlockBase.extend({
  addNodeView() {
    return (props) => {
      const blockType = props.node.attrs.blockType as string | null;

      if (blockType === "chatbot-tool-status") {
        return chatbotToolStatusRenderer(props);
      }

      return null;
    };
  },
});
